import {
    TOGGLE_SIDEBAR,
} from 'store/actions/types';

const initialState = {
    sidebarOpen: true,
};

export default function ui(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_SIDEBAR:
            return Object.assign({}, state, {
                sidebarOpen: !state.sidebarOpen,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/uiReducer.js